import { render, staticRenderFns } from "./TypeSuscription.vue?vue&type=template&id=ecd5c32c"
import script from "./TypeSuscription.vue?vue&type=script&lang=js"
export * from "./TypeSuscription.vue?vue&type=script&lang=js"
import style0 from "./TypeSuscription.vue?vue&type=style&index=0&id=ecd5c32c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports